import React, { useState } from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';



const ApprovalList = ({ apiRef, columns, rows, error, loading, handleRowClick,columnVisibilityModel }) => {

  const [pageSize, setPageSize] = useState(20);

  if( columnVisibilityModel === null) {

    columnVisibilityModel = {
      // Hide columns status and traderName, the other columns will remain visible
      id: false,
      apprUuid: false,
      docuUuid: false,
      docuCd: false,
      docuTyp: false,
    }
  }

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 240px)',  maxWidth: 'calc(80vw - 40px)',  minWidth: '100%' }}>
      <div style={{ flexGrow: 1 ,  minWidth: '100%' }}>
        <DataGrid
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '결재_리스트' },
          }}
          loading={loading}
          onRowClick={handleRowClick}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default ApprovalList;
